module.exports = __webpack_public_path__ + "static/privacy_background-ea9a7bea47bddba2aa66d32fe6f968a1.jpg";